/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventModel } from './EventModel';
import { EventModelFromJSON, EventModelFromJSONTyped, EventModelToJSON } from './EventModel';

/**
 *
 * @export
 * @interface ListEventResponse
 */
export interface ListEventResponse {
    /**
     *
     * @type {number}
     * @memberof ListEventResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListEventResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListEventResponse
     */
    total: number;
    /**
     *
     * @type {Array<EventModel>}
     * @memberof ListEventResponse
     */
    events: Array<EventModel>;
}

/**
 * Check if a given object implements the ListEventResponse interface.
 */
export function instanceOfListEventResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('events' in value)) return false;
    return true;
}

export function ListEventResponseFromJSON(json: any): ListEventResponse {
    return ListEventResponseFromJSONTyped(json, false);
}

export function ListEventResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListEventResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        events: (json['events'] as Array<any>).map(EventModelFromJSON),
    };
}

export function ListEventResponseToJSON(value?: ListEventResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        events: (value['events'] as Array<any>).map(EventModelToJSON),
    };
}
